import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import App from './App';
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

import './index.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

// TASK-19 (a11y): run axe-core accessibility audits in the dev console only.
if (process.env.NODE_ENV === 'development') {
  import('@axe-core/react').then(({ default: axe }) => {
    axe(React, ReactDOM, 1000);
  });
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {/* Router must wrap providers so they can call useLocation/useNavigate */}
    <Router>
      {/* Provider tree: QueryClientProvider > AuthProvider > TenantProvider > App */}
      {/* AuthProvider and TenantProvider are mounted inside App so they have Router context */}
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </Router>
  </React.StrictMode>
);

// TASK-19: enable PWA install + app-shell offline caching (production only).
serviceWorkerRegistration.register();

reportWebVitals();
